import { get } from "lodash";

import { havePermission } from "../core";
import type { CheckPermission, UseHavePermission } from "../type";
import { usePermissionContext } from "./usePermissionContext";

export const useHavePermission: UseHavePermission = (params) => {
  const checkFn = get(params, "checkFn", havePermission);

  const { permission: _recordPermission } = usePermissionContext();

  const checkPermission: CheckPermission = (record, isUnion = false) => {
    return checkFn({ _recordPermission, record, isUnion });
  };

  return checkPermission;
};
